<template>
    <Icon
        name="loading"
        class="animate-spin"
        :size="size" />
</template>

<script setup lang="ts">

const props = withDefaults(defineProps<{
    size?: 'sm' | 'md' | 'lg' | 'xl'
}>(), {
    size: 'sm'
})

const sizeMap = new Map(
    [
        ['sm', '5'],
        ['md', '8'],
        ['lg', '16'],
        ['xl', '32']
    ]
)

const size = computed(() => {
    return sizeMap.get(props.size)
})

</script>